let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3BloW")).then(() => parcelRequire('4SDWJ'));